<template>

  <div v-title data-title="查看物流">
  <section class="container">
      <div class="delivery-pro">
        <!-- <div class="del-pro-img">
          <img :src="model.ProductImgUrl" />
        </div> -->
        <!-- <p class="del-pro-t">{{model.ProductName}}</p> -->
        <div class="delivery-status">
           {{crabType.Type}}-{{crabType.Name}}
        </div>
      </div>
      <div class="delivery-details">
        <div class="delivery-num">
          {{model.LogisticsInfo.com}}
          <span>
            {{model.LogisticsInfo.number}}
          </span>
        </div>
        <ul class="del-details-list">
          <li
            :class="$index==0?'del-carry-out':'del-carry-on'"
            v-for="(item,$index) in traces"
            :key="$index"
          >
            <div class="fl">
              {{item.time.split(' ')[0].substring(5)}}
              <br />
              {{item.time.split(' ')[1]}}
            </div>
            <div class="fr">
              <div
                :class="$index==0?'del-send-others':$index==traces.length-1?'del-shipments':'del-send-others'"
              >
                <p v-if="$index==traces.length-1" class="del-details-t">已发货</p>
                <p >{{item.desc}}</p>
              </div>
            </div>
            <div class="clear"></div>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import Vue from "vue";
import thumb from "../../assets/logo.png";
import { Dialog } from "we-vue";
import wx from "weixin-js-sdk";
import { debug } from "util";

export default {
  name: "viewlogistics",
  data: function() {
    return {
      orderGuid: "",
      model: {},
      traces: [],
      crabType:{},
      show: false,
    };
  },
  created: function() {
      this.model.LogisticsInfo= JSON.parse(this.$route.query.LogisticsInfo);
      this.traces= this.model.LogisticsInfo.traces.reverse();
      this.crabType=JSON.parse(this.$route.query.CrabType)
  },
};
</script>

<style scoped>
body {
  font-size: 12px;
}

ul li {
  list-style: none;
}

.track-rcol {
  width: 900px;
  border: 1px solid #eee;
}

.time {
  display: table-cell;
  vertical-align: middle;
  font-size: 14px;
}

.time span {
  display: block;
  font-size: 12px;
}

.track-list {
  margin: 20px;
  padding-left: 40px;
  position: relative;
}

.track-list li {
  position: relative;
  padding: 35px 0 0 0px;
  border-left: 1px solid #d9d9d9;
  color: #999;
}

.track-list li.first {
  color: #f98336;
  padding-top: 0;
  border-left-color: #fff;
}

/* .track-list li .fa fa-circle {
            position: absolute;
            left: -6px;
            top: 50%;
            width: 11px;
            height: 11px;
        } */

.track-list li .time {
  margin-right: 20px;
  position: relative;
  top: 20px;
  right: 55px;
  display: inline-block;
  vertical-align: middle;
}

.track-list li .icon {
  position: relative;
  top: 20px;
  right: 74px;
  display: inline-block;
  border: 8px solid #fff;
  vertical-align: middle;
  z-index: 2;
}

.track-list li .small-icon {
  margin-right: 15px;
  position: relative;
  top: 20px;
  right: 70px;
  display: inline-block;
  vertical-align: middle;
  z-index: 2;
}
.track-list li .small-icon i {
  width: 5px;
  height: 5px;
  background: #ddd;
  border: 8px solid #fff;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  z-index: 10;
}

.track-list li .text {
  margin-right: 20px;
  position: relative;
  top: 20px;
  right: 76px;
  display: inline-block;
  vertical-align: middle;
}
</style>









// WEBPACK FOOTER //
// src/components/crab/logisticsdetail.vue